import * as React from 'react';
import { View,ScrollView } from 'react-native';
import { Text , Appbar  } from 'react-native-paper'

export default function TermsScreen(props) {
    return (
      <View style={{ flex: 1 }}>
      <Appbar.Header>
        <Appbar.BackAction onPress={()=> props.navigation.goBack()} />
        <Appbar.Content title="شرایط و مقررات استفاده" />
      </Appbar.Header>
        <ScrollView contentContainerStyle={{ paddingHorizontal: 24 }}>
          <Text style={{ fontSize:10}}>
{'\n'}
فیت وِیز اولین سامانه هوشمند عضویت روزانه در کلاس های ورزش گروهی ارائه شده از طرف بهترین مجموعه های ورزشی است.
کاربر گرامی، با توجه به اینکه تمامی خدمات ارائه شده در سامانه فیت ویز تابع قوانین مطروح در این بخش است، مطالعه آن پیش از استفاده از خدمات الزامی بوده  با ثبتِ نام کردن و استفاده از سرویس، شما اعلام می‌کنید که شرایط و مقررات زیر را خوانده‌اید و در چهارچوبِ آن عمل می‌کنید. شما تنها هنگاهی قادر به استفاده‌یِ کامل از سرویس می‌شوید که از تمامِ قوانین و توافقاتِ آن پیروی کنید.
{'\n'}
{'\n'}
1-	تعاریف و اصطلاحات
{'\n'}
1-1-	فیت وِیز: سرویس که گروه تجارت الکترونیک شاهکار زندگی ارائه می دهد.
{'\n'}
2-1-	کاربر: هر شخص حقیقی یا حقوقی که در فیت وِیز ثبت نام می کند این فرد می تواند اعم از مشتری یا ارائه دهنده خدمات باشد.
{'\n'}
3-1-	ارائه دهنده خدمات: عبارت است از کاربری که به عنوان برگذارکننده کلاس های ورزش گروهی و ارائه دهنده خدمات ورزشی در فیت وِیز ثبت نام کرده است.
{'\n'}
4-1-	 مشتری: کاربری که متقاضی خدمات فیت وِیز می باشد.
{'\n'}
5-1-	حساب کاربری: شامل صفحه شخصی، نام کاربری و سابقه فعالیت کاربر، که پس از ثبت نام در فیت وِیز در اختیار کاربر قرار می گیرد.
{'\n'}
6-1-	فیت کارت: اشتراک های معرفی شده در فیت ویز برای رزرو خدمات ارائه شده از طرف ارائه دهندگان خدمات
{'\n'}
{'\n'}
2-	خدمات و سرویس ها
{'\n'}
1-2-	فیت ویز ارائه دهنده خدمات بازاریابی و مدیریت آنلاین برای ارائه دهندگان خدمات است. 
{'\n'}
2-2-	فیت وِیز امکان جستجو و عضوبت خدمات ورزشی و سلامتی ارائه شده به صورت روزانه و معرفی رویدادهای ورزشی و سلامتی که توسط مربی ها در مجموعه های ورزشی ارائه می شوند را برای کاربران فراهم می کند.
{'\n'}
3-2-	 فیت وِیز به تنهایی باشگاه ورزشی ، استودیو فیتنس یا مراکز مشابه نیست و مالک، مدیر و کنترل کننده هیچ کدام از خدمات ارائه شده توسط مجموعه های ورزشی نیست. 
{'\n'}
4-2-	خدمات ورزشی شامل کلاس های گروهی و رویدادهای ورزشی ارائه شده در فیت ویز در قالب قوانین جمهوری اسلامی بوده و با توجه به ماهیت فعالیت، خدمات دارای دسته‌بندی ویژه بانوان و آقایان می‌باشد و رزرو برای هر خدمت تنها با در نظر گرفتن این موضوع امکان‌پذیر است. لذا کاربر اقرار می‌نماید که با ایجاد رزرو در فیت ویز این بند را به‌طور کامل مطالعه نموده و نسبت به این امر آگاهی کامل دارد.
{'\n'}
{'\n'}

3-	حقوق و تعهدات فیت ویز
{'\n'}
1-3-	فیت وِیز  متعهد به اجرای قوانین جمهوری اسلامی در کلیهٔ فعالیت‌¬های خود خواهد بود.
{'\n'}
2-3-	فیت وِیز متعهد به تلاش برای ارائه‌ی سرویس پرسرعت و باکیفیت است و در این راستا با به‌روزرسانی مداوم وب سایت و نرم‌افزارها، متناسب با نیاز کاربران، سطح خدمات ارائه‌شده را ارتقاء می‌بخشد.
{'\n'}
تبصره: فیت وِیز نمی‌‌تواند اجرا شدن اپلیکیشن فیت ویز را در تمامی سخت‌افزارها، دستگاه‌های تلفن همراه یا شبکه‌های ارتباطی تضمین نماید.
{'\n'}
3-3-	فیت وِیز متعهد می‌‌شود که اطلاعات ذخیره‌‌شده در اپلیکشین  را تنها در جهت بهبود کیفیت خدمات مذکور استفاده نماید.
{'\n'}
4-3-	فیت ویز کلیه اطلاعات فنی را که کاربران مشاهده می¬‌کنند ردیابی می¬‌کند تا به این ترتیب، قادر به تعیین محبوبیت خدمات و بالا بردن کیفیت خدمات فیت ویز باشد. این اطلاعات در محتویات تبلیغاتی درون سایت یا عملکرد بهتر سرویس‌ها مورد استفاده قرار می‌گیرد.
{'\n'}
5-3-	فیت ویز متعهد است کلیه تغییرات، اصلاحات و الحاقات قرارداد حاضر را اطلاع رسانی و در صفحه مربوط به شرایط و مقررات استفاده در وب سایت WWW.FITWAYZ.IR به‌روزرسانی نماید.
{'\n'}
6-3-	فیت ویز متعهد می¬‌گردد به مشکلات احتمالی اعلام‌شده توسط کاربران در خصوص رزروها و پرداخت‌ها در اسرع وقت رسیدگی نموده و سعی بر رفع مشکلات مذکور نماید.
{'\n'}
تبصره: اعلام مشکلات مذکور تنها توسط کاربر و با همان نام کاربری که سفارش صورت گرفته است، ممکن خواهد بود. در صورتی که نیاز به استرداد وجه باشد استرداد با احراز هویت کاربر و تطابق آن با شماره حساب و یا کارت واریزی صورت خواهد پذیرفت.
{'\n'}
7-3-	فیت وِیز متعهد است اطلاعات شخصی از قبیل نام و شماره تلفن افرادی که اقدام به ثبت نظر خود در مورد خدمات ارائه شده از جانب برگذارکننده می کنند را محفوظ نگه دارد.
{'\n'}
8-3-	هدف اصلی فیت ویز جلب رضایت مشتری است. لیکن در بعضی مواقع در راستای ارائه خدمات ممکن است به دلیل اتفاقات غیرمترقبه و خارج از اختیار فیت ویز، از جمله شرایط اضطراری و فورس ماژور، قطع سراسری شبکه¬‌های ارتباطی، قطع برق، مشکل برای مربی ها و .... در ارائه خدمات اخلال ایجادشده و یا رزروهای ثبت شده لغو گردد. در این صورت هزینه‌های پرداختی توسط مشتری تمام و کمال عودت خواهد شد.
{'\n'}
9-3-	فیت وِیز حق عدم سرویس‌دهی به کاربران را برای خود محفوظ می‌دارد.
{'\n'}
10-3-	فیت وِیز مختار است هرگونه محتوایی که کاربران به تارنما یا اپلیکیشن‌ ها ارسال می‌کنند را به هر نحو که صلاح می‌داند برای توسعه و تبلیغ خدمات خود استفاده نماید.
{'\n'}
{'\n'}
4-	امور مالی
{'\n'}
1-4- دانلود نصب و استفاده از نرم افزارهای فیت ویز رایگان است.
{'\n'}
2-4- میزان اعتبار مورد نیاز برای رزرو هر جلسه از خدمات مورد تایید برگزارکننده آن خدمت است و مشتری در صورت رزرو کلاس هیچ گونه پرداخت دیگری برای دریافت خدمات نخواهد داشت.
{'\n'}
3-4-	ارائه دهنده خدمات ملزم به پذیرش مشتری ای در صورت تایید رزرو درخواست داده شده است.
{'\n'}
4-4-	مشتری به ازای خرید فیت کارت های ارائه شده در نرم افزار امکان رزرو خدمات ارائه دهندگان را دارند. 
{'\n'}
5-4-	در صورت تمایل مشتری به لغو رزرو انجام شده طبق شرایط و مقررات تعریف شده برای هر یک از کلاس ها عمل خواهد شد. به این صورت که اگر تا مدت تایین شده از طرف برگذارکننده درخواست لغو ارسال شد، کل مبلغ به حساب کاربر باز
{'\n'}
6-4-	فیت وِیز ملزم به پرداخت هزینه برگذاری کلاس ظرف مدت 48 ساعت بنا به درخواست برگذارکننده کلاس است.
{'\n'}
7-4-	فیت کارت ها دارای محدودیت زمانی برای استفاده می باشند و در صورتی که کاربر در مدت مشخص از اعتبار تخصیص یافته استفاده نکند با تماس با پشتیبانی امکان تمدید اشتراک وجود دارد در غیر این صورت اعتبار سوخت خواهد شد.
{'\n'}
{'\n'}
5-	 حساب کابری
{'\n'}
1-5-	کاربران با ثبت نام در  فیت وِیز  و همچنین با هر بار استفاده از خدمات فیت وِیز می‌پذیرند که قوانین و مقررات جاری فیت وِیز را به صورت کامل مطالعه کرده و با اطلاع کامل از شرایط و معانی آن پذیرفته‌اند. این قوانین و مقررات ممکن است در طول زمان تغییرکند و بنابراین استفادۀ مستمر کاربران از اپلیکیشن به معنی پذیرش هرگونه تغییر در قوانین و مقررات آن است.
{'\n'}
2-5-	استفاده از فیت ویز منوط به داشتن حساب کاربری است. هر شخص (اعم از حقیقی و حقوقی) تنها مجاز به افتتاح یک حساب کاربری است. در خصوص اشخاص حقوقی، فرد افتتاح ‌کننده حساب کاربری، باید نماینده قانونی شرکت باشد.
{'\n'}
3-5-	کاربر می‌پذیرد اطلاعات درخواست شده توسط فیت وِیز را به طور صحیح و دقیق ارئه نماید و در صورت نیاز به تغییر اطلاعات در اسرع وقت نسبت به به‌روز‌رسانی آن‌ها اقدام نماید. مسئولیت عدم تطابق اطلاعات مندرج با واقع و کلیه عواقب ناشی از آن بر عهده خود کاربر خواهد بود.
{'\n'}
4-5-	هر کاربر با ثبت‌نام در فیت وِیز و ایجاد حساب کاربری به نام خود صحت انتساب تمام داده پیام‌‌های صادره از حساب کاربری خویش را پذیرفته و در نتیجه حق هرگونه اعتراض یا ادعای آتی (مبنی بر انکار، تردید یا جعل داده‌ پیام‌های ارسالی) را از خویش سلب و اسقاط می‌‌نماید.
{'\n'}
5-5-	مسئولیت تمامی فعالیت‌هایی که از طریق حساب کاربری انجام می‌‌شود مطلقاً به‌عهده صاحب حساب کاربری است، در نتیجه کاربر مجاز نیست حساب کاربری خود را برای استفاده در اختیار شخص دیگری قرار دهد یا آن را به هر نحو به دیگری منتقل نماید. به علاوه ضروری است که در راستای ممانعت از سوء استفاده غیر، در حفظ اطلاعات حساب کاربری خود، حداکثر اقدامات لازم را مبذول دارد.
{'\n'}
تبصره: در صورت ظن به دسترسی اشخاص ثالث به حساب کاربری، کاربر موظف برای انجام پیگیری‌های بیشتر شرکت را مطلع سازد.
{'\n'}
6-5-	در راستای اطلاع‌رسانی اخبار، خدمات و سرویس‌های ویژه از جمله تخفیف‌ها، کلاس ها و رویدادها فیت ویز اقدام به ارسال رایانامه و یا پیامک برای اعضا فیت ویز می‌نماید. در صورتی که کاربر تمایلی به دریافت این پیام‌ها و یا رایانامه‌ها نداشته باشند قادر به لغو این موارد خواهد بود.
{'\n'}
تبصره: با توجه به اینکه اطلاع رسانی در خصوص خدمات از درگاه‌های مذکور صورت می‌پذیرد و نظر به امکان ایجاد اختلال در روند خدمت‌رسانی، در صورت لغو این سرویس‌ها، مسئولیتی متوجه شرکت نیست و کاربر حق اعتراض در این مورد را از خود سلب می‌نماید.
{'\n'}
7-5-	فیت وِیز مجاز است در صورت صلاحدید پیش از استفاده کاربر از حساب کاربری برای اطمینان از صحت اطلاعات، کاربران را احراز هویت نماید.
{'\n'}
{'\n'}
6-	شرایط استفاده کاربران از فیت ویز
{'\n'}
1-6-	ارائه دهندگان خدمات تمامی تعهدات مربوط به اخذ مجوز های لازم و رعایت قوانین و مقررات قانونی و شرعی و بیمه ورزشی برای خدمات معرفی شده را می پذیرد.
{'\n'}
2-6-	مشتری ملزم به اخذ بیمه ورزشی برای شرکت در کلاس های گروهی می باشد و مسولیت هرگونه حوادث ورزشی بر عهده خود مشتری می باشد.
{'\n'}
3-6-	کاربر برای شرکت در کلاس های گروهی باید کارت شناسایی خود را به همراه داشته باشد. 
{'\n'}
4-6-	تایید و یا رد درخواست رزرو انجام شده از طرف مشتری برای شرکت در کلاس های گروهی معرفی شده بر عهده برگذارکننده کلاس است و فیت وِیز هیچ گونه مسولیتی در این مورد ندارد.
{'\n'}
5-6-	در کلیه¬‌ مراحل استفاده از فیت وِیز، کاربران موظف به رعایت قوانین جمهوری اسلامی ایران هستند.
{'\n'}
6-6-	کاربر می‌پذیرد تمامی تغییرات، الحاقات و اصلاحاتی را که توسط شرکت در وب سایت فیت ویز به‌روزرسانی می‌گردد و یا از طریق پیامک، رایانامه، نرم‌افزارهای فیت وِیز و یا هر شیوه‌ی متعارف دیگر در خصوص استفاده از خدمات فیت وِیز و شرایط آن ارسال‌‌ می‌گردد را مطالعه نماید. لذا هرگونه استفاده از فیت وِیز به منزله‌ی اطلاع کامل و موافقت با موارد مذکور خواهد بود.
{'\n'}
7-6-	کاربر می‌‌پذیرد که قرارداد حاضر یک قرارداد قابل رجوع و جایز از سوی شرکت است و شرکت می‌‌تواند هر زمان تنها به صلاحدید خود و بدون دلیل، یک حساب کاربری را مسدود کند و مانع استفاده‌ی کاربر از خدمات فیت وِیز گردد.
{'\n'}
8-6-	کاربر می تواند در صورت تمایل اقدام به رزرو گروهی خدمات ارائه شده کند.
{'\n'}
9-6-	کاربر شرایط و مقررات ورود به کلاس ها شامل زمان ورود، وسایل مورد نیاز و ... که در صفحه پروفایل هر کلاس معرفی شده را می پذیرد.
{'\n'}
{'\n'}
7-	رزرو خدمات
{'\n'}
1-7-	برای استفاده از خدمات مشتری باید در اپلیکیشن فیت وِیز ثبت نام نموده و رزرو خدمات مورد نظر را تایید نماید، در صورت نهایی شدن رزرو هزینه خدمات از اعتبار کاربر در اپلیکیشن کم می شود.
{'\n'}
تبصره: تایید رزرو تنها در صورت داشتن اعتبار کافی امکان پذیر است.
{'\n'}
2-7-	بعد از توافقات نهایی مشتری موظف است در زمان مقرر در محل بیان شده (نشانی ارائه دهنده خدمات) حضور یابد در صورت عدم حضور هیچ مسولیتی بر عهده فیت وِیز و یا برگذارکننده نمی باشد.
{'\n'}
3-7-	ثبت نظر و یا پیشنهادات مشتریان در خصوص خدمات ارائه‌شده امکان‌پذیر است. لیکن باید در نظر داشت که نظرات مذکور در هر صفحه باید تنها در قالب نقد و بررسی همان خدمت ارائه‌شده توسط وی باشد. در این باب رعایت کامل ادب و نزاکت، شئونات اسلامی و عرف جامعه الزامی است. لذا فیت ویز محق است ضمن حفظ محتوای اصلی، کلیه نظراتی که با اخلاق حسنه و شئونات اسلامی و قوانین موضوعه و قرارداد حاضر در تضاد باشند را حذف نماید.
{'\n'}
 تبصره: فیت ویز هیچ گونه مسئولیتی در قبال صحت یا عدم صحت نظرات منتشر شده در خصوص سرویس‌ها ندارد. نمایش نظرات کاربران به هیچ وجه به معنی تأیید فنی فیت ویز درباره محتویات نظر نیست.
 {'\n'}
 {'\n'}
8-	مالکیت معنوی
{'\n'}
1-8-	فیت ویز متعهد است که اطلاعات کلیه کاربران را از قبیل اطلاعات شخصی اطلاعات مشتریان(نام، شماره تلفن، و ...) اطلاعات مالی و مدیریتی را محرمانه تلقی و در اختیار اشخاص ثالث قرار ندهد، مگر به موجب قوانین و یا دستور مراجع قضایی و یا سایر مراجع ذی صلاح قانونی .
{'\n'}
2-8-	کلیه حقوق معنوی نرم‌افزارهای فیت وِیز، موارد وابسته به آن و هر آنچه بدان ملحق می‌گردد، مانند نام، علامت تجاری، خدمات ارائه‌شده تحت این نام و سایر موارد از جمله مالکیت فکری و معنوی آن متعلق به گروه تجارت الکترونیک شاهکار زندگی بوده و هر گونه سوء استفاده از هر یک از موارد فوق قابلیت پیگیری قانونی خواهد داشت. لذا کاربران در همه حال متعهد به رعایت حقوق معنوی شرکت نسبت به نرم‌افزارها و ملحقات آن بوده، تنها مجاز به استفاده‌ی محدود، غیر انحصاری و غیر قابل انتقال از خدمات فیت ویز هستند، بدون آن که این استفاده حقی برای آن‌ها نسبت به مالکیت نرم‌افزارهای فیت ویز یا سایر حقوق معنوی مربوطه ایجاد نماید یا اجازه‌ی استفاده از نام، علامت تجاری، لوگو و ... را به آن‌ها اعطا نماید.
{'\n'}
3-8-	کاربران نمی‌‌توانند نرم‌افزارهای فیت ویز را تغییر دهند و یا آن را بازتولید، مشابه سازی یا بازنویسی کنند یا از جزء یا کل آن برای تولید یک برنامه‌ی مشابه یا غیر مشابه استفاده نمایند.
{'\n'}
4-8-	اقدام کاربر برای دسترسی به هر یک از سرویس‌‌ها و برنامه‌ها و شبکه‌ها‌ی مرتبط با سرورها، همچنین استفاده از مهندسی معکوس یا مترجم وارون برای دسترسی به کد سطح بالا یا زبان ماشین یا تلاش در راستای آن غیر مجاز بوده و تخلف محسوب می‌گردد و فیت ویز مجاز به پیگیری‌های قانونی و برخورد با شخص خاطی خواهد بود.
{'\n'}
5-8-	کپی‌برداری از اطلاعات برگذارکنندگان و یا مشتریان، محتوی، طراحی و تصاویر به کار رفته در نرم افزارهای فیت ویز، چه به شکل دستی و یا خودکار، ممنوع می‌باشد.
{'\n'}
{'\n'}
9-	حل اختلاف
{'\n'}
1-9-	مشتری و ارائه دهنده خدمات می‌پذیرند که در صورت بروز هرگونه مشکل درنهایت آرامش و به دور از هرگونه تشنج مشکل مربوطه را با صلح و سازش و از طریق مذاکره حل نمایند. در صورتی که رفع مشکل از این طریق امکان‌پذیر نبود هر یک از طرفین می‌توانند شکایت خود را به فیت ویز ابلاغ نماید. در این حالت فیت ویز با توجه به مستندات، نظر کارشناس و با در نظر گرفتن قوانین، رأی صادر می‌نماید.
{'\n'}
تبصره: مشتری و متخصص می‌پذیرند رأی فیت ویز در این خصوص نهایی بوده و برای طرفین الزام‌آور است.
{'\n'}
2-9-	در صورت بروز اختلاف بین کاربران و فیت ویز، طرفین تلاش خواهند کرد اختلاف را به‌صورت مسالمت‌آمیز حل و فصل نمایند. در صورت عدم موفقیت، اختلاف به هیئت داوری مرضی‌الطرفین ارجاع داده خواهد شد.
{'\n'}
3-9-	کلیهٔ قوانین حاکم در نظام جمهوری اسلامی ایران بر تعبیر، تفسیر، اجرا و تأثیر این توافق‌نامه حاکم خواهد بود.
{'\n'}
4-9-	این مقررات بر اساس ماده ۱۰ قانون مدنی به‌عنوان یک قرارداد الزام‌آور بر روابط بین کاربر و فیت ویز حاکم بوده و هرگونه ادعا یا اعتراض آتی کاربر را در این خصوص بلا اعتبار می‌سازد.
{'\n'}
          </Text>
        </ScrollView>
      </View>
    );
  }